import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateZoneDocument } from './create.generated';

export const useCreateZone = (options: ApiOptions<typeof CreateZoneDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(CreateZoneDocument, {
    ...useNotifications(CreateZoneDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.zones.create_success'),
    }),

    ...options,
  });
};
